import styled from '@emotion/styled';

export const LinkedAttachmentName = styled.a`
  color: ${({ theme }) => theme.colors.secondary};
`;

export const AttachmentsLabel = styled.span`
  display: inline-block;
  margin-right: 5px;
  font-family: ${({ theme }) => theme.fonts.secondary};
`;
